const NAME = "ALERTS_SETTINGS_PAGE";

export default NAME;
